import { render, staticRenderFns } from "./OtpBlock.vue?vue&type=template&id=30dd7612&"
import script from "./OtpBlock.vue?vue&type=script&lang=js&"
export * from "./OtpBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports